module.exports = __webpack_public_path__ + "img/logo-analytics.51f857ed.webp";